import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage, blogIndexHead } from "@/pages/BlogIndexPage";

export const Route = createFileRoute("/artikler/")({
  head: () => blogIndexHead("da"),
  component: () => <BlogIndexPage locale="da" />,
});
